var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0866FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9946 4.00333L13.8359 4C11.4107 4 9.8434 5.54552 9.8434 7.93762V9.75313H7.67293C7.48538 9.75313 7.3335 9.89927 7.3335 10.0795V12.71C7.3335 12.8903 7.48555 13.0363 7.67293 13.0363H9.8434V19.6738C9.8434 19.854 9.99528 20 10.1828 20H13.0147C13.2022 20 13.3541 19.8539 13.3541 19.6738V13.0363H15.8919C16.0794 13.0363 16.2313 12.8903 16.2313 12.71L16.2324 10.0795C16.2324 9.99299 16.1965 9.91009 16.133 9.84884C16.0694 9.78758 15.9828 9.75313 15.8928 9.75313H13.3541V8.2141C13.3541 7.47438 13.5375 7.09886 14.54 7.09886L15.9942 7.09836C16.1816 7.09836 16.3335 6.95222 16.3335 6.77211V4.32958C16.3335 4.14964 16.1818 4.00366 15.9946 4.00333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtFacebook);
export default __webpack_public_path__ + "static/media/bt_facebook.ff269a6db81433d3982c64a3a2960474.svg";
export { ForwardRef as ReactComponent };